import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link';
import TranslationProvider from '../../providers/TranslationProvider';

import './VenueAnnouncement.scss';

const VenueAnnouncement = ({
  announcement,
  venueName,
}) => {
  // eslint-disable-next-line camelcase
  if (!announcement || announcement?.external_links?.length === 0) {
    return null;
  }

  const {
    // eslint-disable-next-line camelcase
    external_links,
  } = announcement;

  function renderLinks(lis, name) {
    if (!lis || !lis.length) { return null; }

    lis.sort(
      (a, b) => {
        if (a.link_category < b.link_category) {
          return -1;
        }
        if (a.link_category > b.link_category) {
          return 1;
        }
        return 0;
      }
    );

    return (
      <>
        <TranslationProvider translationKey="venue_support" translationValues={{ venueName: name }}>
          <div className="venue-support">Other ways to support:</div>
        </TranslationProvider>
        <ul>
          {lis.map((link) => (
            <li key={link.link}>
              <Link
                href={link.link}
                target="_blank"
              >
                {link.link_label}
              </Link>
            </li>
          ))}
        </ul>
      </>
    );
  }

  return (
    <div className="VenueAnnouncement">
      {/* eslint-disable-next-line camelcase */}
      <div>{renderLinks(external_links, venueName)}</div>
    </div>
  );
};

VenueAnnouncement.propTypes = {
  announcement: PropTypes.shape({
    external_links: PropTypes.arrayOf(
      PropTypes.shape({
        link_label: PropTypes.string,
        link: PropTypes.string,
        link_category: PropTypes.string,
      })
    ),
    headline: PropTypes.string,
    subheadline: PropTypes.string,
  }),
  venueName: PropTypes.string,
};

VenueAnnouncement.defaultProps = {
  announcement: null,
  venueName: '',
};

export default VenueAnnouncement;
